import { render } from "./branch-stats-filter.vue?vue&type=template&id=a97049aa&scoped=true"
import script from "./branch-stats-filter.vue?vue&type=script&lang=js"
export * from "./branch-stats-filter.vue?vue&type=script&lang=js"

import "./branch-stats-filter.vue?vue&type=style&index=0&id=a97049aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a97049aa"]])

export default __exports__